import * as ACTIONS from '../constants/actionTypes';
import KEYS from '../constants/keyCodes';

export default {
  [ACTIONS.CAMERA_LEFT]: KEYS.LEFT,
  [ACTIONS.CAMERA_UP]: KEYS.UP,
  [ACTIONS.CAMERA_RIGHT]: KEYS.RIGHT,
  [ACTIONS.CAMERA_DOWN]: KEYS.DOWN,

  [ACTIONS.CAMERA_ROTATE_CLOCKWISE]: KEYS.R,
  [ACTIONS.CAMERA_ROTATE_COUNTER_CLOCKWISE]: KEYS.E,
  [ACTIONS.CAMERA_CYCLE_ZOOM]: KEYS.Z,

  [ACTIONS.TOGGLE_DEBUG_OVERLAY]: KEYS.D,
};



// WEBPACK FOOTER //
// ./src/config/keyMapping.js